import { defineStore } from "pinia";
import axios from "axios";
import { apiConfig } from "@/config/apiConfig";

const getAccessToken = () => localStorage.getItem("accessToken");

export const useClassStore = defineStore("classStore", {
  state: () => ({
    classInfoList: [],
    studentList: [],
    schoolInfoList: [],
    navItems: [],
    loading: false,
    error: null,
    query: "",
  }),
  actions: {
    setClassInfoList(data) {
      try {
        this.classInfoList = Array.isArray(data)
          ? data
          : typeof data === "string"
            ? JSON.parse(data)
            : [];
        this.updateNavItems();
      } catch (e) {
        console.error("Error setting class info list:", e);
        this.classInfoList = [];
      }
    },

    setStudentList(data) {
      this.studentList = Array.isArray(data) ? data : [];
    },

    updateNavItems() {
      this.navItems = (this.classInfoList || []).map((item) => ({
        title: item.name,
        link: `/students/${item.id}`,
      }));
    },
    async fetchClassInfoList() {
      this.loading = true;
      this.error = null;
      try {
        const accessToken = getAccessToken();
        if (!accessToken) {
          throw new Error("No access token found. Please log in first.");
        }

        const response = await axios.get(
          `${apiConfig.baseUrl}${apiConfig.classinfo}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          
          }
        );

        this.setClassInfoList(response.data);
      } catch (error) {
        this.error = error.message || "Failed to fetch class info";
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async SearchClassInfoList(query) {
      // console.log("called seaqrch funxtion...", query);
      this.loading = true;
      this.error = null;
      try {
        const accessToken = getAccessToken();
        if (!accessToken) {
          throw new Error("No access token found. Please log in first.");
        }

        const response = await axios.get(
          `${apiConfig.baseUrl}${apiConfig.classinfo}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
             params: {
            name: query,
          },

          
          }
        );

        this.setClassInfoList(response.data);
      } catch (error) {
        this.error = error.message || "Failed to fetch class info";
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async handleInput() {
      // console.log("handel input called...")
      try {
            this.classInfoList = await this.SearchClassInfoList(this.query);
          } catch (error) {
            console.error(error.message);
          }
    },

    


    async fetchStudentsByClassId(classId) {
      try {
        const accessToken = getAccessToken();
        const response = await axios.get(
          `${apiConfig.baseUrl}${apiConfig.studentsDetail}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "CLASS-ID": classId,
            },
          }
        );
        this.setStudentList(response.data);
        return response.data;
      } catch (error) {
        console.error("Failed to fetch students:", error);
        throw error;
      }
    },
  },
  getters: {
    getClassDropdownItems(state) {
      return (state.classInfoList || []).map((item) => ({
        title: item.name,
        value: item.id,
      }));
    },

    getStudentList(state) {
      return state.studentList || [];
    },

    // New getter for loading state
    isLoading(state) {
      return state.loading;
    },

    // New getter for error
    getError(state) {
      return state.error;
    },
  },
});

export const useSchoolStore = defineStore("schoolStore", {
  state: () => ({
    schoolInfoList: [],
  }),
  actions: {
    setSchoolInfoList(data) {
      this.schoolInfoList = data;
    },
  },
  getters: {
    getSchoolInfoList(state) {
      // This getter returns the schoolInfoList directly
      return state.schoolInfoList;
    },
  },
});
